import {Box, Button, Container, Grid, Typography} from "@mui/material";
import {useParams, Link} from "react-router-dom";
import posts from "../../data/post.json";
import diego from '../../Recursos/diego.png'
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Blog_Home from "./Componentes/Blog_Home";

const Seccion_Blog_Post = () => {
    const {id} = useParams();
    const post = posts.find((p) => p.id === id);

    if (!post) {
        return <Typography variant="h6">Post no encontrado</Typography>;
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{maxWidth: 1400, px: 3, pt: 16}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <ArrowBackIosNewIcon sx={{color: "primary.main", fontSize: 20, mr: 1}}/>
                    <Typography
                        component={Link}
                        to="/blog"
                        sx={{
                            textDecoration: "none",
                            color: "primary.main",
                            fontWeight: "bold",
                            "&:hover": {textDecoration: "underline"},
                        }}
                    >
                        Volver al blog
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:8}}>
                    <Typography variant="body1">
                        {post.fechaPublicacion}
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                    <Typography variant="h1" gutterBottom>
                        {post.titulo}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <img src={diego} width="80px"/>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                        <Typography variant='h5'>
                            {post.autor}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid
                    container
                    size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                    <Typography variant="body1">
                        {post.descripcion}
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:4}}>
                    {post.contenido.map((section, index) => (
                        <section key={index}>
                            <Typography variant='h2' sx={{pt:2}}>{section.subtitulo}</Typography>
                            {section.parrafos.map((texto, i) => (
                                <Typography variant='body1' key={i}>{texto}</Typography>
                            ))}
                        </section>
                    ))}
                </Grid>



            </Grid>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{pt:8}}>
                <Blog_Home/>
            </Grid>
        </Grid>
    )
}
export default Seccion_Blog_Post;